import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 flex items-center justify-center z-50"
}
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "flex-shrink-0 mr-4" }
const _hoisted_4 = {
  key: 0,
  class: "h-8 w-8 text-blue-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_5 = {
  key: 1,
  class: "h-8 w-8 text-green-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_6 = {
  key: 2,
  class: "h-8 w-8 text-yellow-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_7 = {
  key: 3,
  class: "h-8 w-8 text-red-400",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = { class: "flex justify-between items-start" }
const _hoisted_10 = { class: "text-base text-gray-300" }
const _hoisted_11 = {
  key: 0,
  class: "mt-4 flex justify-end"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Transition, { name: "toast-fade" }, {
    default: _withCtx(() => [
      (_ctx.show)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-30 backdrop-blur-sm" }, null, -1)),
            _createElementVNode("div", {
              class: _normalizeClass(["bg-gray-800 text-white rounded-lg shadow-xl border border-gray-700 p-5 max-w-md z-10 transform transition-all duration-300", [_ctx.typeClasses, 'scale-100 opacity-100']])
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  (_ctx.type === 'info')
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_4, _cache[2] || (_cache[2] = [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        }, null, -1)
                      ])))
                    : (_ctx.type === 'success')
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _cache[3] || (_cache[3] = [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                          }, null, -1)
                        ])))
                      : (_ctx.type === 'warning')
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_6, _cache[4] || (_cache[4] = [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                            }, null, -1)
                          ])))
                        : (_ctx.type === 'error')
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_7, _cache[5] || (_cache[5] = [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h3", {
                      class: _normalizeClass(["text-lg font-medium mb-2", _ctx.titleColorClass])
                    }, _toDisplayString(_ctx.title || _ctx.defaultTitle), 3),
                    _createElementVNode("button", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeToast && _ctx.closeToast(...args))),
                      class: "ml-4 text-gray-400 hover:text-gray-300 transition-colors"
                    }, _cache[6] || (_cache[6] = [
                      _createElementVNode("svg", {
                        class: "h-5 w-5",
                        viewBox: "0 0 20 20",
                        fill: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                          "clip-rule": "evenodd"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.message), 1),
                  (_ctx.showAction)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("button", {
                          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAction && _ctx.handleAction(...args))),
                          class: _normalizeClass(["px-4 py-2 rounded-md text-sm font-medium transition-colors", _ctx.actionButtonClass])
                        }, _toDisplayString(_ctx.actionText), 3)
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}